export default __webpack_public_path__ + "static/media/radio-unselected-light.91a3a005.svg";